import React, {useState} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import {ReactComponent as RedLogo} from "./images/logo_big_svg.svg";
import UserInfo from "./Me/components/UserInfo";
import { Link } from 'react-router-dom';
import {format} from 'date-fns';
import ru from 'date-fns/locale/ru'
import useInterval from "./util/useInterval";
import {withStyles} from "@material-ui/styles";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        paddingTop: 59
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: 'white',
        position: 'fixed',
        "z-index": 1201,
        marginTop: 0,
        marginBottom: 0,
        top: 0,
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        paddingRight: 0,
    },
    toolbarLeft: {
        display: 'flex',
        alignItems: 'center',
    },
    menuButton: {
        marginRight: theme.spacing(2),
        color: '#5A6E78',
    },
    title: {
        flexGrow: 1,
    },
    date: {
        marginLeft: '30px',
        color: '#596E79',
    },
    time: {
        margin: '0 5px 0 20px',
        color: '#596E79'
    },
    timeText: {
        color: '#596E79',
    },
    arrowOrg: {
        color: '#ffffff',
        display: 'inline-block',
    }
}));

const calcToday = () => format(
    new Date(),
    'dd MMMM yyyy',
    {locale: ru}
);

const calcCurrentTime = () => format(
    new Date(),
    'HH:mm'
);

export default function ButtonAppBar({onMenuClick}) {

    const classes = useStyles();

    let [today, setToday] = useState(() => calcToday());
    let [currentTime, setCurrentTime] = useState(() => calcCurrentTime());

    useInterval(() => {
        setToday(calcToday());
        setCurrentTime(calcCurrentTime());
    }, 3000);

    return (
        <>
            <div className={classes.root}>
                <AppBar className={classes.appBar} position="static">
                    <Toolbar className={classes.toolbar}>
                        <div className={classes.toolbarLeft}>
                            <IconButton onClick={onMenuClick} edge="start" className={classes.menuButton} color="inherit"
                                        aria-label="menu">
                                <MenuIcon fontSize="large"/>
                            </IconButton>
                            <Link to="/work/app/dashboard">
                              <RedLogo/>
                            </Link>
                            <div className={classes.date}>{`Сегодня, ${today}`}</div>
                            <AccessTimeIcon className={classes.time} fontSize="small"/>
                            <div className={classes.timeText}>{currentTime}</div>
                        </div>
                        <div className={classes.toolbarLeft}>
                            <NotificationsNoneIcon className={classes.timeText} fontSize="small"/>
                            <UserInfo/>
                        </div>
                    </Toolbar>
                </AppBar>
            </div>

        </>
    );
}
